<template>
  <div id="app" :class="this.$route.name == 'SingpassData' ? 'hide_padding' : 'show_padding'">
    <!-- <CommonSearchActionSchemaComponent/> -->
    <router-view/>
  </div>
</template>

<script>
// import CommonSearchActionSchemaComponent from './components/website/CommonSchemaComponent/CommonSearchActionSchemaComponent.vue';
export default {
  name: 'App',
  // components: {
  //   CommonSearchActionSchemaComponent,
  // },
  mounted() {
    // x-app-rendered is dispatched by each prerenderable page component after its
    // data loads (e.g. HomeNew.vue). App.vue must not fire it here because
    // $router.onReady resolves before child components and their API calls complete.
  },
}
</script>
